export const basicDetails = (data = {}) => dispatch => {
    dispatch({
        type: 'BASIC_DETAILS',
        payload: data
    })
}

export const getTranslation = () => dispatch => {
    const labelsUrl = (window.location.hostname === "localhost") ? "https://components.test.flysas.com/sfb-www-api/labels/?market=lu-en&tag=sfb-corporate-signup" : `https://components.flysas.com/sfb-www-api/labels/?market=${getMarketLanguage()}&tag=sfb-corporate-signup`
    fetch(labelsUrl)
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            dispatch({
                type: 'LABEL_DETAILS',
                payload: data
            })

        });
}

export const getCountry = () => dispatch => {
    const labelsUrl = (window.location.hostname === "localhost") ? "https://api2.test.flysas.com/v2/cms-www-api/data/geo/countries?market=se-sv" : `https://api2.flysas.com/v2/cms-www-api/data/geo/countries?market=${getMarketLanguage()}`
    fetch(labelsUrl)
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            dispatch({
                type: 'COUNTRY',
                payload: data
            })

        });

}

 const getMarketLanguage = () => {
    const href = window.location.href
    if (href.match(/.+\.sas\.se/)) {
        return "se-sv"
    } else if (href.match(/.+\.sas\.no/)) {
        return "no-no"
    } else if (href.match(/.+\.sas\.dk/)) {
        return "dk-da"
    } else if (href.match(/.+\.sas\.fi/)) {
        return "fi-en"
    } else if (href.match(/\/resmal\//)) {
        return "se-sv"
    } else if (href.match(/\/reisemal\//)) {
        return "no-no"
    } else if (href.match(/\/rejsemaal\//)) {
        return "dk-da"
    }

    return getMarketByPathname(href).toLowerCase()

}
const getMarketByPathname = (href) => {
    return (href.match(/\/([a-z]{2}-[a-z]{2})(\/|$).*/i) || [])[1] || "lu-en"
}


export const getSessionStorage = () => dispatch => {
    dispatch({
        type: 'SESSION_STORAGE',
        payload: JSON.parse(window.sessionStorage.getItem('prof-profile'))
    })
}


export const registerResponse = (data = {}) => dispatch => {
    dispatch({
        type: 'CONNCETD_RESPONSE',
        payload: data
    })
}

export const postApiCall = request => {

    return new Promise((resolve, reject) => {
        fetch(request.url, {
            method: 'POST',
            headers: request.headers,
            body: request.body
        }).then((response) => {
            if (!response.ok) {
                throw { status: response.status }
            }
            return response
        }).then(response => response.json())
            .then(resolve)
            .catch(reject)
    })
}
export const getApiData = request => {
    return new Promise((resolve, reject) => {
        const headers = request.headers;
        fetch(request.url, { headers })
            .then(response => {
                if (!response.ok) {
                    throw { status: response.status }
                }
                return response
            })
            .then(response => response.json())
            .then(resolve)
            .catch(reject)
    })
}





